import { MenuBook, Home, AccessAlarm } from "@mui/icons-material";
import { PATHS } from "../routes/paths";

function OrderIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="currentColor" d="m17.275 20.25l3.475-3.45l-1.05-1.05l-2.425 2.375l-.975-.975l-1.05 1.075zM6 9h12V7H6zm12 14q-2.075 0-3.537-1.463T13 18t1.463-3.537T18 13t3.538 1.463T23 18t-1.463 3.538T18 23M3 22V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v6.675q-.7-.35-1.463-.513T18 11H6v2h7.1q-.425.425-.787.925T11.675 15H6v2h5.075q-.05.25-.062.488T11 18q0 1.05.288 2.013t.862 1.837L12 22l-1.5-1.5L9 22l-1.5-1.5L6 22l-1.5-1.5z"></path></svg>
  )
}

export function getNavConfig(user) {
  return [
    // {
    //   label: 'Produtos',
    //   icon: <Inventory />,
    //   children: [
    //     {
    //       label: 'Itens',
    //       icon: <ListAlt />,
    //       path: PATHS.products.items
    //     },
    //     {
    //       label: 'Categorias',
    //       icon: <Category />,
    //       path: PATHS.products.categories
    //     }
    //   ]
    // },
    {
      label: 'Início',
      icon: <Home/>,
      path: '/'
    },
    {
      label: 'Cardápio',
      icon: <MenuBook />,
      path: PATHS.menu
    },
    {
      label: 'Horários',
      icon: <AccessAlarm />,
      path: PATHS.schedule
    },
    ...user ? [
      {
        label: 'Meus Pedidos',
        icon: <OrderIcon />,
        path: PATHS.orders
      }
    ] : []
  ]
}